import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CmAuthService, CmInterceptHeaders } from '@ats/cm/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { CmImageNotFound } from '../models';

@Pipe({
    name: 'cmSecureImage',
    standalone: false
})
export class CmSecureImagePipe implements PipeTransform {
	constructor(private http: HttpClient, private auth: CmAuthService, private sanitizer: DomSanitizer) {}

	transform(src: string): Observable<SafeUrl> {
		const token = this.auth.getAuthToken();
		const headers = new HttpHeaders({
			Authorization: `Bearer ${token}`,
			...CmInterceptHeaders.BypassAuth,
		});
		return this.http.get(src, { headers, responseType: 'blob' }).pipe(
			map(blob => this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))),
			catchError(err => of(CmImageNotFound.ImageNotFound)),
			take(1)
		);
	}
}
